import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Layout extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M12.3,5H0.7L0,4.3V1.7L0.7,1h11.6L13,1.7v2.6L12.3,5z M1.4,3.6h10.2V2.4H1.4V3.6z" />
          <path d="M15.3,10H3.7L3,9.3V6.7L3.7,6h11.6L16,6.7v2.6L15.3,10z M4.4,8.6h10.2V7.4H4.4V8.6z" />
          <path d="M12.3,15H0.7L0,14.3v-2.6L0.7,11h11.6l0.7,0.7v2.6L12.3,15z M1.4,13.6h10.2v-1.2H1.4V13.6z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Layout.js